import { SERVER_URL, ServerEnv } from './base-url';

const env: ServerEnv = 'dev';

export const environment = {
  appName: 'Amoxcalli Padres',
  env,
  production: false,
  serverUrl: SERVER_URL[env],
};
